/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimWithCaptchaParams } from '../models/CreateClaimWithCaptchaParams';
import type { ListResponse_SelectItem_ } from '../models/ListResponse_SelectItem_';
import { request as __request } from '../core/request';

export class ClaimsService {

    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static async create(
        requestBody: CreateClaimWithCaptchaParams,
    ): Promise<void> {
        const result = await __request({
            method: 'POST',
            path: `/claims/create`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns ListResponse_SelectItem_ Ok
     * @throws ApiError
     */
    public static async getVisibleDocsType(): Promise<ListResponse_SelectItem_> {
        const result = await __request({
            method: 'GET',
            path: `/claims/visibleDocsType`,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param qr
     * @returns string Ok
     * @throws ApiError
     */
    public static async checkCardQr(
        qr: string,
    ): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/claims/card/qr/check`,
            query: {
                'qr': qr,
            },
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param qrData
     * @returns string Ok
     * @throws ApiError
     */
    public static async getCardQr(
        qrData: string,
    ): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/claims/cardQr`,
            query: {
                'qrData': qrData,
            },
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}